(() => {
  'use strict';
  const detail = document.querySelector('[data-product-detail]');
  if (!detail) return;
  const preview = document.body.dataset.preview === 'true';
  const data = JSON.parse(detail.querySelector('[data-product-data]').textContent);
  const money = amount => {
    const format = data.moneyFormat || '€{{amount_with_comma_separator}}';
    const token = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    const decimals = token.includes('no_decimals') ? 0 : 2;
    const comma = token.includes('comma_separator');
    const group = token.includes('space_separator') ? ' ' : token.includes('apostrophe_separator') ? "'" : comma ? '.' : ',';
    const decimal = comma || token === 'amount_with_space_separator' ? ',' : '.';
    const parts = (Number(amount || 0) / 100).toFixed(decimals).split('.');
    const value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) + (decimals ? decimal + parts[1] : '');
    const html = document.createElement('span');
    html.innerHTML = format.replace(/\{\{\s*\w+\s*\}\}/, value);
    return html.textContent;
  };
  const gallery = detail.querySelector('[data-gallery]');
  const photo = gallery.querySelector('[data-gallery-image]');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  let galleryIndex = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
  function showPhoto(index, announce = true) {
    if (!thumbs.length) return;
    galleryIndex = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[galleryIndex];
    photo.classList.add('is-changing');
    photo.onload = () => photo.classList.remove('is-changing');
    photo.onerror = () => { photo.classList.remove('is-changing'); gallery.querySelector('[data-gallery-status]').textContent = 'This photo could not load. Please choose another photograph.'; };
    photo.src = thumb.dataset.src;
    photo.alt = thumb.dataset.alt;
    if (photo.complete) photo.classList.remove('is-changing');
    thumbs.forEach((t,i) => t.setAttribute('aria-pressed', String(i === galleryIndex)));
    gallery.querySelector('[data-gallery-index]').textContent = `${String(galleryIndex+1).padStart(2,'0')} / ${String(thumbs.length).padStart(2,'0')}`;
    if (announce) gallery.querySelector('[data-gallery-status]').textContent = `Photo ${galleryIndex+1} of ${thumbs.length}: ${thumb.dataset.alt}`;
  }
  thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => showPhoto(i)));
  gallery.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => showPhoto(galleryIndex + Number(button.dataset.galleryStep))));
  gallery.addEventListener('keydown', event => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    if (!event.target.closest('[data-gallery-thumb], [data-gallery-step]')) return;
    event.preventDefault();
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length-1 : galleryIndex + (event.key === 'ArrowRight' ? 1 : -1);
    showPhoto(index);
    thumbs[galleryIndex]?.focus();
  });
  let touchStart = null;
  gallery.querySelector('.gallery-stage').addEventListener('touchstart', e => { touchStart = {x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY}; }, {passive:true});
  gallery.querySelector('.gallery-stage').addEventListener('touchend', e => {
    if (!touchStart) return;
    const dx=e.changedTouches[0].clientX-touchStart.x, dy=e.changedTouches[0].clientY-touchStart.y;
    if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.3) showPhoto(galleryIndex+(dx<0?1:-1));
    touchStart=null;
  }, {passive:true});
  const form = detail.querySelector('.pdp-purchase');
  const quantity = form.querySelector('[data-quantity]');
  const variantInput = form.querySelector('[name="id"]');
  const addButton = form.querySelector('[data-add-button]');
  const status = form.querySelector('[data-purchase-status]');
  let variant = data.variants.find(v => String(v.id) === variantInput.value) || data.variants[0];
  function normalizeQuantity() {
    const value = Number(quantity.value);
    quantity.value = String(Math.max(1, Math.min(99, Number.isFinite(value) ? Math.floor(value) : 1)));
    return Number(quantity.value);
  }
  function updatePurchase() {
    const count = normalizeQuantity();
    form.querySelector('[data-quantity-step="-1"]').disabled = count <= 1;
    form.querySelector('[data-quantity-step="1"]').disabled = count >= 99;
    const price = detail.querySelector('[data-product-price]');
    if (price) price.textContent = money(variant.price);
    const total = form.querySelector('[data-add-total]');
    if (total) total.textContent = money(variant.price * count);
    addButton.disabled = !variant.available;
    form.querySelector('[data-add-label]').textContent = variant.available ? 'Add to bag' : (form.querySelector('[data-add-label]').dataset.unavailableLabel || 'Sold out');
    const measurement=variant.unit_price_measurement;
    const unitPrice = detail.querySelector('[data-unit-price]');
    if (unitPrice) unitPrice.textContent=measurement?`${money(variant.unit_price)} / ${measurement.reference_value} ${measurement.reference_unit}`:'';
    const comparison=detail.querySelector('[data-compare-price]');
    if(comparison){comparison.hidden=!(variant.compare_at_price>variant.price);comparison.textContent=money(variant.compare_at_price || 0);}
  }
  form.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => { quantity.value=String(normalizeQuantity()+Number(button.dataset.quantityStep));updatePurchase(); }));
  quantity.addEventListener('change', updatePurchase);
  quantity.addEventListener('blur', updatePurchase);
  quantity.addEventListener('input', () => {
    if (quantity.value !== '') updatePurchase();
  });
  variantInput.addEventListener('change', () => {
    variant=data.variants.find(v=>String(v.id)===variantInput.value)||data.variants[0];
    updatePurchase();
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
    if(variant.featured_image){const index=thumbs.findIndex(t=>String(t.dataset.imageId)===String(variant.featured_image.id));if(index>=0)showPhoto(index,false);}
    status.textContent=variant.available?'':(form.querySelector('[data-add-label]').dataset.unavailableLabel === 'Coming soon' ? 'Coming soon.' : 'This option is currently sold out.');
  });
  const requestedVariant=new URLSearchParams(location.search).get('variant');
  if(requestedVariant&&data.variants.some(v=>String(v.id)===requestedVariant)){variantInput.value=requestedVariant;variant=data.variants.find(v=>String(v.id)===requestedVariant);}
  updatePurchase();
  if (!preview) return;
  const drawer = document.querySelector('#preview-bag');
  const storageKey = 'gentlemen-farmers-preview-bag-v2';
  let bag = [];
  try {
    const saved=JSON.parse(localStorage.getItem(storageKey)||'[]');
    if(Array.isArray(saved))bag=saved.filter(i=>i&&Number.isFinite(i.price)&&i.price>=0&&Number.isInteger(i.quantity)&&i.quantity>0&&i.quantity<=99&&typeof i.title==='string'&&typeof i.url==='string'&&i.url.startsWith('/products/')&&typeof i.image==='string'&&i.image.startsWith('/assets/')&&typeof i.variantId==='string');
  } catch { bag=[]; }
  let bagTrigger=null;
  function saveBag() { try { localStorage.setItem(storageKey,JSON.stringify(bag)); } catch { /* The bag still works in memory when browser storage is restricted. */ } }
  function renderBag() {
    const lines=drawer.querySelector('[data-bag-lines]');lines.replaceChildren();
    let total=0,count=0;
    for(const item of bag){
      count+=item.quantity;total+=item.quantity*item.price;
      const fragment=drawer.querySelector('[data-bag-line-template]').content.cloneNode(true);
      const line=fragment.querySelector('.bag-line');line.dataset.variantId=item.variantId;
      fragment.querySelectorAll('[data-line-link]').forEach(link=>link.href=item.url);
      fragment.querySelector('[data-line-image]').src=item.image;
      fragment.querySelector('[data-line-image]').alt=item.title;
      fragment.querySelector('[data-line-title]').textContent=item.title;
      fragment.querySelector('[data-line-option]').textContent=item.option || 'Extra virgin olive oil';
      fragment.querySelector('[data-line-total]').textContent=money(item.quantity*item.price);
      fragment.querySelector('[data-line-quantity]').textContent=item.quantity;
      fragment.querySelector('[data-line-step="-1"]').disabled=item.quantity<=1;
      fragment.querySelector('[data-line-step="1"]').disabled=item.quantity>=99;
      lines.append(fragment);
    }
    document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=count;});
    document.querySelectorAll('[data-cart-open]').forEach(el=>el.setAttribute('aria-label',`Open your bag, ${count} ${count===1?'item':'items'}`));
    drawer.querySelector('[data-bag-item-count]').textContent=`(${count})`;
    drawer.querySelector('[data-bag-total]').textContent=money(total);
    drawer.querySelector('[data-bag-empty]').hidden=bag.length>0;
    drawer.querySelector('[data-bag-footer]').hidden=!bag.length;
  }
  function openBag(trigger) { bagTrigger=trigger;renderBag();if(!drawer.open)drawer.showModal(); }
  document.querySelectorAll('[data-cart-open]').forEach(button=>button.addEventListener('click',()=>openBag(button)));
  drawer.querySelectorAll('[data-cart-close]').forEach(button=>button.addEventListener('click',()=>drawer.close()));
  drawer.addEventListener('close',()=>bagTrigger?.focus({preventScroll:true}));
  drawer.addEventListener('click',event=>{
    const control=event.target.closest('[data-line-step],[data-line-remove]');
    if(!control)return;
    const line=control.closest('[data-variant-id]');const item=bag.find(i=>i.variantId===line.dataset.variantId);if(!item)return;
    const id=item.variantId;const focusSelector=control.hasAttribute('data-line-remove')?null:`[data-line-step="${control.dataset.lineStep}"]`;
    if(control.hasAttribute('data-line-remove'))bag=bag.filter(i=>i!==item);else item.quantity=Math.min(99,Math.max(1,item.quantity+Number(control.dataset.lineStep)));
    saveBag();renderBag();
    const target=focusSelector?[...drawer.querySelectorAll('[data-variant-id]')].find(l=>l.dataset.variantId===id)?.querySelector(focusSelector):null;
    if(target&&!target.disabled)target.focus();else drawer.querySelector('[data-cart-close]').focus();
  });
  form.addEventListener('submit', event=>{
    event.preventDefault();
    if(!form.reportValidity()||!variant.available)return;
    const count=normalizeQuantity();const existing=bag.find(i=>i.variantId===String(variant.id));
    if(existing){existing.quantity=Math.min(99,existing.quantity+count);existing.price=variant.price;}else bag.push({variantId:String(variant.id),title:data.title,url:data.url,image:data.image,option:variant.title==='Default Title'?'Extra virgin olive oil':variant.title,price:variant.price,quantity:count});
    saveBag();renderBag();status.textContent=`${count} ${count===1?'item':'items'} added to your preview bag.`;openBag(addButton);
  });
  renderBag();
})();
